import { TDepartmentTabs, ISurveyReportInfo } from '@/schemas/survey';
import * as services from '@services/index';

interface State {
  departments: TDepartmentTabs;
  reportData: ISurveyReportInfo;
}

const initState: State = {
  departments: [],
  reportData: {} as ISurveyReportInfo
};

const doctors = {
  state: initState,

  reducers: {
    updateState(state: State, payload) {
      return {
        ...state,
        ...payload
      };
    }
  },

  effects: (_dispatch) => ({
    async getDepartments() {
      try {
        const result = await services.survey.queryDepartmentList();
        this.updateState({
          departments: result.map((dep) => ({
            key: dep.departmentId,
            value: dep.departmentName
          }))
        });
      } catch (ignore) {
        // ignore
      }
    },
    async getReport(surveyCode) {
      try {
        const result = await services.survey.queryRecordDetail({
          surveyCode
        });
        this.updateState({
          reportData: result
        });
      } catch (ignore) {
        // ignore
      }
    }
  })
};

export default doctors;
